import { Extension } from '@tiptap/core'
import { storeToRefs } from 'pinia'

import { ActionButton } from '@/components/editor'
import { useEditorStore } from '@/stores'
import type { GeneralOptions } from '@/types'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    preview: {
      togglePreview: () => ReturnType
    }
  }
}

export type PreviewOptions = GeneralOptions<PreviewOptions>

export const Preview = Extension.create<PreviewOptions>({
  name: 'preview',
  addOptions() {
    return {
      ...this.parent?.(),
      button: () => ({
        component: ActionButton,
        componentProps: {
          icon: 'Eye',
          action: () => {
            const editorStore = useEditorStore()
            editorStore.togglePreview()
          },
          tooltip: 'Preview',
          ignoreDisabled: true,
          isActive: () => {
            const editorStore = useEditorStore()
            const { showPreview } = storeToRefs(editorStore)
            return showPreview.value
          },
        },
      }),
    }
  },
  addCommands() {
    return {
      togglePreview: () => () => {
        const editorStore = useEditorStore()
        editorStore.togglePreview()
        return true
      },
    }
  },
})
